<!--
 * @Author: ZhaoG
 * @Date: 2025-05-31 15:24:49
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-04 19:27:26
 * @FilePath: \gcp-fe\src\app\shop\components\detail-tables.vue
 * @Description: 
-->
<template>
  <div>
    <template>
      <el-table
        :data="tableData"
        :span-method="objectSpanMethod"
        :fit="true"
        @selection-change="selectionChange"
        border
        class="multifunctional-table dic-sub-table-style01"
      >
        <el-table-column
          type="index"
          :width="commonTableWidth.serialNoWidth"
          :label="$t('page.content.serialNo')"
          align="center"
        >
          <template #default="scope">
            <span class="tips" v-if="isFBSupCode == 10000"
              >仅已登录分包商可见</span
            >
            <span class="tips" v-else>完成登录后即可查看</span>
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableHead">
          <el-table-column
            :key="index"
            :label="table.label"
            :width="table.width"
            :min-width="table.width"
            :prop="table.prop"
            :align="table.align"
            :header-align="table.headerAlign"
            :show-overflow-tooltip="true"
            :formatter="table.formatter"
            v-if="!table.isHidden"
          >
            <template #default="scope">
              <span class="tips" v-if="isFBSupCode == 10000"
                >仅已登录分包商可见</span
              >
              <span class="tips" v-else>完成登录后即可查看</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
  </div>
</template>

<script>
import { commonTableWidth } from "@/setting/setting";
import Cookies from "js-cookie";

export default {
  name: "detail-table",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commonTableWidth: commonTableWidth,
      accessToken: "",
      isFBSupCode: ""
    };
  },
  mounted() {
    this.isFBSupCode = sessionStorage.getItem("fbSupCode");
    this.accessToken = Cookies.get("access_token");
    console.log(this.isFBSupCode == 10000 && this.accessToken);
  },
  methods: {
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, this.tableHead.length + 1];
      } else {
        return [0, 0];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tips {
  color: #eb090c;
  font-size: 14px;
  display: block;
  line-height: 60px;
}
</style>
